import axios from "axios";

// Same-origin Cloudflare Pages Functions live under /api — no separate backend.
export const API = "/api";

export const api = axios.create({ baseURL: API });

export const fmtEUR = (n) =>
  new Intl.NumberFormat("el-GR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const fmtInt = (n) => new Intl.NumberFormat("el-GR").format(Number(n || 0));
